/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// <TABLET/>SP>メインスライド
	const mainVisSwiper = () => {
		if(document.querySelector('.js-top-mainSlide')) {
			const splide1 = new Splide('.js-top-mainSlide.splide', {
				type: 'fade',
				rewind: true,
				perPage: 1,
				autoplay: true,
				interval: 4000,
				speed: 1000,
				arrows: false,
				pagination: false,
				pauseOnHover: false,
			});
			splide1.mount();
		}
	};

	const mainMovie = () => {
		// YouTube IFrame APIスクリプトを動的に追加
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		const stopIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#stop_circle"></use></svg>';
		const playIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#play_circle"></use></svg>';
	
		// 動画設定
		let player;
		let thisId = document.querySelector('#movie').getAttribute('data-id');
	
		// YouTube IFrame APIが読み込まれたときに実行されるコールバック関数
		function onYouTubeIframeAPIReady() {
			player = new YT.Player('movie', {
				videoId: thisId,
				playerVars: {
					'loop': 1,
					'autoplay': 1,
					'controls': 0,         // コントロールバー非表示
					'mute': 1,             // ミュート
					'rel': 0,              // 関連動画非表示（完全非表示は不可、同一チャンネル優先）
					'disablekb': 1,        // キーボード操作無効化
					'playsinline': 1,      // インライン再生（モバイル対応）
					'showinfo': 0,         // 動画情報を非表示（非推奨だが一部対応）
					'modestbranding': 1,   // YouTubeロゴを小さくする
					'fs': 0,               // フルスクリーンボタン非表示
				},
				events: {
					'onStateChange': onPlayerStateChange
				}
			});
		}
	
		// プレイヤーの状態が変化したときに実行されるイベントハンドラ
		function onPlayerStateChange(e) {
			let status = e.target.getPlayerState();
			if (status === YT.PlayerState.ENDED) {
				player.playVideo();
				player.mute();
			}
		}
	
		// 再生/停止ボタンの制御
		function setupControlButton() {
			const stopBtn = document.querySelector('.js-stopBtn');
			let isPlaying = true; // 動画の再生状態をトグルで管理
	
			stopBtn.addEventListener('click', () => {
				if (player) {
					if (isPlaying) {
						player.pauseVideo(); // 再生中の場合は一時停止
						stopBtn.querySelector('.__txt').textContent = 'Play';
						stopBtn.querySelector('svg').outerHTML = playIcon;
					} else {
						player.playVideo(); // 停止中の場合は再生
						stopBtn.querySelector('.__txt').textContent = 'Stop';
						stopBtn.querySelector('svg').outerHTML = stopIcon;
					}
					isPlaying = !isPlaying; // 状態を反転
				}
			});
		}
	
		// YouTube APIの初期化
		window.onYouTubeIframeAPIReady = () => {
			onYouTubeIframeAPIReady();
			setupControlButton(); // ボタンの設定
		};
	};

		
	// <TOPICS>スライド
	const topicsSwiper = () => {
		let splide = new Splide('.top-topics-list.splide', {
			// type: 'loop',
			perPage: 4,
			// focus: 0,
			autoplay: false,
			interval: 5000,
			speed: 1000,
			arrows: true,
			pagination: false,
			paginationKeyboard: true,
			gap: 20,
			breakpoints: {
				1025: {
					perPage: 1,
				}
			},
		}).mount();
	};

	// ================================================================
	mainVisSwiper();
	if(document.querySelector('#movie')) {
		mainMovie();
	}
	topicsSwiper();


})(window.FUNCTIONS);
